// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"d07deeb1","180":"9e75bef6","809":"9e9f6209"}[chunkId] + ".chunk.js";
};